import React, { useEffect, useState } from "react";
import {
  getFaqs,
  addFaq,
  updateFaq,
  deleteFaq,
} from "../../lib/firebase/firestore";
import styles from "../../styles/AdminFaqs.module.css";

export const AdminFaqs = () => {
  const [faqs, setFaqs] = useState<
    { id: string; question: string; answer: string }[]
  >([]);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [editingId, setEditingId] = useState<string | null>(null);

  const fetchFaqs = async () => {
    const data = await getFaqs();
    setFaqs(data);
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (editingId) {
      await updateFaq(editingId, { question, answer });
      setEditingId(null);
    } else {
      await addFaq({ question, answer });
    }

    setQuestion("");
    setAnswer("");
    fetchFaqs();
  };

  const handleEdit = (faq: {
    id: string;
    question: string;
    answer: string;
  }) => {
    setEditingId(faq.id);
    setQuestion(faq.question);
    setAnswer(faq.answer);
  };

  const handleDelete = async (id: string) => {
    await deleteFaq(id);
    fetchFaqs();
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Manage FAQs</h2>

      {/* Form */}
      <form onSubmit={handleSubmit} className={styles.form}>
        <input
          type="text"
          placeholder="Question"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          required
          className={styles.input}
        />
        <textarea
          placeholder="Answer"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          required
          className={styles.textarea}
        />
        <div className={styles.formActions}>
          <button type="submit" className={`${styles.btn} ${styles.primary}`}>
            {editingId ? "Update FAQ" : "Add FAQ"}
          </button>
          {editingId && (
            <button
              type="button"
              onClick={() => {
                setEditingId(null);
                setQuestion("");
                setAnswer("");
              }}
              className={`${styles.btn} ${styles.ghost}`}
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* FAQ List */}
      {faqs.length > 0 ? (
        <div className={styles.list}>
          {faqs.map((faq) => (
            <div key={faq.id} className={styles.listItem}>
              <div>
                <p className={styles.q}>{faq.question}</p>
                <p className={styles.a}>{faq.answer}</p>
              </div>
              <div className={styles.actions}>
                <button
                  onClick={() => handleEdit(faq)}
                  className={styles.iconBtn}
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(faq.id)}
                  className={styles.iconBtn}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className={styles.empty}>No FAQs found. Add some above!</p>
      )}
    </div>
  );
};
